import {

  GET_MEMBER_DEFINITIONS,
  GET_MEMBER_DEFINITIONS_SUCCESS,
  ADD_NEW_MEMBER_DEFINITION,
  ADD_MEMBER_DEFINITION_SUCCESS,
  UPDATE_MEMBER_DEFINITION,
  UPDATE_MEMBER_DEFINITION_SUCCESS,
  DELETE_MEMBER_DEFINITION,
  DELETE_MEMBER_DEFINITION_SUCCESS,
  MEMBER_DEFINITION_API_ERROR


} from "./actionTypes"

export const getMemberDefinitions = () => ({
  type: GET_MEMBER_DEFINITIONS,
})

export const getMemberDefinitionsSuccess = memberDefinition => ({
  type: GET_MEMBER_DEFINITIONS_SUCCESS,
  payload: memberDefinition,
})

export const addNewMemberDefinition = memberDefinition => ({
  type: ADD_NEW_MEMBER_DEFINITION,
  payload: memberDefinition,
})

export const addMemberDefinitionSuccess = memberDefinition => ({
  type: ADD_MEMBER_DEFINITION_SUCCESS,
  payload: memberDefinition,
})

export const updateMemberDefinition = memberDefinition => ({
  type: UPDATE_MEMBER_DEFINITION,
  payload: memberDefinition,
})

export const updateMemberDefinitionSuccess = memberDefinition => ({
  type: UPDATE_MEMBER_DEFINITION_SUCCESS,
  payload: memberDefinition,
})

export const deleteMemberDefinition = guid => ({
  type: DELETE_MEMBER_DEFINITION,
  payload: guid,
})

export const deleteMemberDefinitionSuccess = guid => ({
  type: DELETE_MEMBER_DEFINITION_SUCCESS,
  payload: guid,
})

export const memberDefinitionsApiError = error => ({
  type: MEMBER_DEFINITION_API_ERROR,
  payload: error,
})

